import { Http } from '../../shared';
import { settings } from '../../settings';

export class EmailService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.b2c_api;
    }


    async sendOrderCreationEmail(id, data) {
        var response = await this.http.post(this.service_url + '/emails/orders/' + id + '/send', { email_template: 'creation', attach_pdf: true, ...data });
        return response.data;
    }
    async sendOrderCancellationEmail(id, data) {
        var response = await this.http.post(this.service_url + '/emails/orders/' + id + '/send', { email_template: 'cancellation', attach_pdf: false, attach_qrcode: false, ...data });
        return response.data;
    }
    async sendLegCancellationEmail(id, data) {
        var response = await this.http.post(this.service_url + '/emails/orders/' + id + '/send', { email_template: 'leg-cancellation', attach_pdf: true, ...data });
        return response.data;
    }
    async sendOrderChangeEmail(id, data) {
        var response = await this.http.post(this.service_url + '/emails/orders/' + id + '/send', { email_template: 'change', attach_pdf: true, ...data });
        return response.data;
    }
    async sendAccountCreationEmail(data) {
        var response = await this.http.post(this.service_url + '/account/creation/send/', { ...data });
        return response.data;
    }
}
